import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const routes = [
  {
    path: '/',
    name: '',
    redirect: '/home',
    component: () => import('@/layout'),
    children: [
      {
        path: '/home',
        name: '首页',
        component: () => import('views/home/index'),
        meta: { headerBg: false, breadcrumb: false },
        children: [
          {
            path: '/home/projectList/projectDetail',
            name: '项目详情',
            component: () => import('views/home/projectList/projectDetail'),
            meta: { breadcrumb: true }
          }
        ]
      },
      {
        path: '/home1',
        name: '首页',
        component: () => import('views/home1/index'),
        meta: { headerBg: false, breadcrumb: false },
        children: [
          {
            path: '/home/projectList/projectDetail',
            name: '项目详情',
            component: () => import('views/home1/projectList/projectDetail'),
            meta: { breadcrumb: true }
          }
        ]
      },
      {
        path: '/help',
        name: '帮助',
        // redirect: '/personal/dataBoard',
        component: () => import('views/help/index'),
      },
      {
        path: '/personal',
        name: '个人中心',
        // redirect: '/personal/dataBoard',
        component: () => import('views/personalCenter/index'),
        children: [
          {
            path: '/personal/dataBoard',
            name: '我的主页',
            component: () => import('views/personalCenter/personal/dataBoard/index')
            // meta: { isDetail: true },
            // children: [
            //   {
            //     path: '/personal/dataBoard/initMap',
            //     name: '地图找房',
            //     component: () => import('views/personalCenter/personal/dataBoard/initMap'),
            //     meta: { isDetail: true }
            //   }
            // ]
          },
          {
            path: '/personal/userInfo',
            name: '我的信息',
            component: () => import('views/personalCenter/personal/userInfo')
          },
          {
            path: '/personal/accountManage',
            name: '账号管理',
            component: () => import('views/personalCenter/personal/accountManage')
          },
          {
            path: '/personal/accountManagePhone',
            name: '账号管理-手机绑定',
            component: () => import('views/personalCenter/personal/accountManage/phone')
          },
          {
            path: '/personal/accountManageEmail',
            name: '账号管理-邮箱绑定',
            component: () => import('views/personalCenter/personal/accountManage/email')
          },
          {
            path: '/personal/accountManagePassword',
            name: '账号管理-修改密码',
            component: () => import('views/personalCenter/personal/accountManage/password')
          },
          {
            path: '/personal/workLog',
            name: '办事记录',
            component: () => import('views/personalCenter/personal/workLog'),
            children: [
              {
                path: '/personal/workLog/rentingDetail',
                name: '租房补贴详情',
                component: () => import('views/personalCenter/logDetail/rentingDetail'),
                meta: { isDetail: true }
              },
              {
                path: '/personal/workLog/highendDetail',
                name: '高端人才公寓详情',
                component: () => import('views/personalCenter/logDetail/highendDetail'),
                meta: { isDetail: true }
              },
              {
                path: '/personal/workLog/agoraDetail',
                name: '市场化人才公寓详情',
                component: () => import('views/personalCenter/logDetail/agoraDetail'),
                meta: { isDetail: true }
              },
              {
                path: '/personal/workLog/baseDetail',
                name: '基础性人才公寓详情',
                component: () => import('views/personalCenter/logDetail/baseDetail'),
                meta: { isDetail: true }
              },
              {
                path: '/personal/workLog/highlevelDetail',
                name: '高层次人才分类认定详情',
                component: () => import('views/personalCenter/logDetail/highlevelDetail'),
                meta: { isDetail: true }
              },
              {
                path: '/personal/workLog/newCompetition',
                name: '创新大赛详情页',
                component: () => import('views/personalCenter/logDetail/newCompetition'),
                meta: { isDetail: true }
              },
              {
                path: '/personal/workLog/landassessDetail',
                name: '落地评估详情',
                component: () => import('views/personalCenter/logDetail/landassessDetail'),
                meta: { isDetail: true }
              },
              // 个人租房补贴详情startRentDetails
              {
                path: '/cPersonal/workLog/startRentDetails',
                name: '个人租房补贴详情',
                component: () => import('views/personalCenter/logDetail/startRentDetails'),
                meta: { isDetail: true }
              },
              // 办公用房补贴详情
              {
                path: '/cPersonal/workLog/startOfficeDtails',
                name: '办公用房补贴详情',
                component: () => import('views/personalCenter/logDetail/startOfficeDtails'),
                meta: { isDetail: true }
              },
              // 创业基金详情
              {
                path: '/cPersonal/workLog/Application',
                name: '创业基金申请详情',
                component: () => import('views/personalCenter/logDetail/Application'),
                meta: { isDetail: true }
              }
            ]
          },
          {
            path: '/personal/draft',
            name: '草稿记录',
            component: () => import('views/personalCenter/personal/draft')
          },
          {
            path: '/cPersonal/dataBoard',
            name: '单位主页',
            component: () => import('views/personalCenter/company/dataBoard')
          },
          {
            path: '/cPersonal/accountManage',
            name: '账号管理',
            component: () => import('views/personalCenter/company/accountManage')
          },
          {
            path: '/cPersonal/businessLog',
            name: '业务记录',
            component: () => import('views/personalCenter/company/businessLog'),
            children: [
              {
                path: '/personal/workLog/rentingDetail',
                name: '租房补贴详情',
                component: () => import('views/personalCenter/logDetail/rentingDetail'),
                meta: { isDetail: true }
              }
              // {
              //   path: '/personal/workLog/highendDetail',
              //   name: '高端人才公寓详情',
              //   component: () => import('views/personalCenter/logDetail/highendDetail'),
              //   meta: { isDetail: true }
              // }
              // {
              //   path: '/cPersonal/workLog/agoraDetail',
              //   name: '市场化人才公寓详情',
              //   component: () => import('views/personalCenter/logDetail/agoraDetail'),
              //   meta: { isDetail: true }
              // }
              // {
              //   path: '/cPersonal/workLog/baseDetail',
              //   name: '基础性人才公寓详情',
              //   component: () => import('views/personalCenter/logDetail/baseDetail'),
              //   meta: { isDetail: true }
              // },
              // {
              //   path: '/cPersonal/workLog/highlevelDetail',
              //   name: '高层次人才分类认定详情',
              //   component: () => import('views/personalCenter/logDetail/highlevelDetail'),
              //   meta: { isDetail: true }
              // }
            ]
          },
          {
            path: '/cPersonal/quarterLog',
            name: '季报记录',
            component: () => import('views/personalCenter/company/quarterLog')
          },
          {
            path: '/cPersonal/quarterLog/fill',
            name: '季报记录',
            component: () => import('views/personalCenter/company/quarterLog/fill')
          },
          {
            path: '/cPersonal/quarterLog/detail',
            name: '季报记录详情',
            component: () => import('views/personalCenter/company/quarterLog/detail')
          },
          {
            path: '/cPersonal/userInfo',
            name: '单位信息',
            component: () => import('views/personalCenter/company/userInfo')
          },
          {
            path: '/cPersonal/accept',
            name: '企业认定',
            component: () => import('views/personalCenter/company/accept')
          }
        ]
      },
      {
        path: '/startUpMatch',
        name: '创业之星大赛',
        component: () => import('views/policyDeclare/startUpMatch/index'),
        meta: { isMatch: true },
        children: [
          {
            path: '/startUpMatch/matchForm',
            name: '创业之星大赛填报',
            component: () => import('views/policyDeclare/startUpMatch/matchForm')
          },
          {
            path: '/startUpMatch/declareInventory',
            name: '创业之星大赛填报',
            component: () => import('views/policyDeclare/startUpMatch/declareInventory')
          },
          {
            path: '/startUpMatch/userImpower',
            name: '创业之星大赛填报',
            component: () => import('views/policyDeclare/startUpMatch/userImpower')
          },
          {
            path: '/startUpMatch/userAgreement',
            name: '创业之星大赛填报',
            component: () => import('views/policyDeclare/startUpMatch/userAgreement')
          },
          {
            path: '/startUpMatch/declareSuccess',
            name: '创业之星大赛填报',
            component: () => import('views/policyDeclare/startUpMatch/userAgreement')
          }
        ]
      },
      {
        path: '/TalentIdentifiy/applicationMaterials',
        name: '分类认定',
        component: () => import('views/TalentIdentifiy/applicationMaterials')
      },
      {
        path: '/policyDeclare/highLevel',
        name: '高层次人才认定',
        component: () => import('views/policyDeclare/highLevel')
      },
      {
        path: '/policyDeclare/rentSubsidies',
        name: '租房补贴',
        component: () => import('views/policyDeclare/rentSubsidies')
      },
      {
        path: '/policyDeclare/hignEndTalentApartment',
        name: '高端人才公寓',
        component: () => import('views/policyDeclare/hignEndTalentApartment')
      },
      {
        path: '/policyDeclare/marketizeTalentApartment',
        name: '市场化人才公寓',
        component: () => import('views/policyDeclare/marketizeTalentApartment')
      },
      {
        path: '/policyDeclare/basicsTalentApartment',
        name: '基础性人才公寓',
        component: () => import('views/policyDeclare/basicsTalentApartment')
      },
      {
        path: '/policyDeclare/startOfficeSubsidies',
        name: '办公用房补贴',
        component: () => import('views/policyDeclare/startOfficeSubsidies')
      },
      {
        path: '/policyDeclare/startRentSubsidies',
        name: '个人租房补贴',
        component: () => import('views/policyDeclare/startRentSubsidies')
      },
      {
        path: '/policyDeclare/starVentureCapital',
        name: '创业引导资金申请',
        component: () => import('views/policyDeclare/starVentureCapital')
      },
      {
        path: '/personal/initMap',
        name: '地图找房',
        component: () => import('views/personalCenter/personal/BusinessHand'),
        meta: { isDetail: true }
      },
      {
        path: '/noticePreview',
        name: '资讯预览',
        component: () => import('views/noticePreview'),
        meta: { isDetail: true }
      },
      {
        path: '/about',
        name: '关于我们',
        component: () => import('views/about'),
        meta: { isDetail: true }
      },
      {
        path: '/policyDeclare/landassess',
        name: '落地评估',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('views/policyDeclare/landassess')
      },
      {
        path: '/notifyDynamic',
        name: '人才资讯',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('views/notifyDynamic/index')
      }
    ]
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('views/login')
  },
  {
    path: '/forgetPass',
    name: '忘记密码',
    component: () => import('views/login/forgetPass')
  },
  {
    path: '/register',
    name: '注册账号',
    component: () => import('views/login/register')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
// router.afterEach(() => {
//   document.body.scrollTop = 0
//   document.documentElement.scrollTop = 0
// })
router.beforeEach((to, from, next) => {
  const token = window.localStorage.getItem('access-token')
  const userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
  if (!token) {
    if (!to.path.includes('initMap') && to.path.includes('personal')) {
      // 未登录不可跳转用户中心
      next('/login')
    } else {
      next()
    }
  } else if (userInfo && to.path.includes('personal') && !to.path.includes('workLog') && !to.path.includes('initMap')) {
    const pathArr = to.path.split('/')
    const isPersonal = pathArr[1] === 'personal' // 判断当前路由是个人还是企业
    // 判断用户类型阻止跳转不同类型账户路由
    if (userInfo.userType === 1) {
      if (isPersonal) {
        next()
      } else {
        next('/personal/dataBoard')
      }
    } else if (userInfo.userType === 2) {
      if (isPersonal) {
        next('/cPersonal/dataBoard')
      } else {
        next()
      }
    }
    // 切换路由时重置滚动条
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
  document.title = to.name
  next()
})

export default router
